import PropTypes from"prop-types";export const jutroYearShape=PropTypes.shape({year:PropTypes.number.isRequired});